export enum TokenType {
    AccessToken = "access-token",
    RefreshToken = "refresh-token",
}

export enum UserType {
    Student = 0,
    Teacher = 1,
    PrincipalTeacher = 2,
    FranchiseMaster = 10,
    Master = 100,
}

export enum UserStatus {
    Active = 0, // 활성
    Inactive = 1, // 비활성
    Suspended = 2, // 정지
    Deleted = 3,
}
export enum TeacherRole {
    /** 담임선생님 */
    MainTeacher = 0,
    /** 보조선생님 */
    SubTeacher = 1,
    TeachingAssistant = 3,
}
export enum RankListOrderType {
    point = 0,
    studyRate = 1,
}
export enum GradeType {
    ElemantarySchool1 = 1, // 초등학교
    ElemantarySchool2 = 2,
    ElemantarySchool3 = 3,
    ElemantarySchool4 = 4,
    ElemantarySchool5 = 5,
    ElemantarySchool6 = 6,
    MiddleSchool1 = 7, // 중학교
    MiddleSchool2 = 8,
    MiddleSchool3 = 9,
    HighSchool1 = 10, // 고등학교
    HighSchool2 = 11,
    HighSchool3 = 12,
}
export enum StudentOrderType {
    EarnedPoint = 0, // 획득 포인트
    CorrectAnswerRate = 1, // 학습 정답률
    // 인기도
}
